export const validateCardExpiryDate = (expiryString) => {
  const expiry = expiryString.split(" ").join("");
  if (!expiry) {
    return { valid: false, message: "Expiry date is not available" };
  }
  const [month, year] = expiry.split("/");
  const currentYear = new Date().getFullYear().toString().slice(-2);
  const currentMonth = new Date().getMonth() + 1;

  if (!month || !year) {
    return { valid: false, message: "Expiry date is not available" };
  }

  if (
    expiry &&
    month &&
    year &&
    (Number.parseInt(year) < Number.parseInt(currentYear) ||
      (Number.parseInt(year) === Number.parseInt(currentYear) &&
        Number.parseInt(month) < currentMonth))
  ) {
    return { valid: false, message: "Your card is expired" };
  }
  return { valid: true, message: "Expiry is valid" };
};
